
const slogan1 = require('../assets/slogans/111.png');
const slogan2 = require('../assets/slogans/222.png');
const slogan3 = require('../assets/slogans/333.png');
const slogan4 = require('../assets/slogans/444.png');

const realEstate1 = require('../assets/realEstate/111.png');
const realEstate2 = require('../assets/realEstate/222.png');
const realEstate3 = require('../assets/realEstate/333.png');


const badroom = require('../assets/badroom.png');
const bathroom = require('../assets/bathroom.png');
const propType = require('../assets/propType.png');

const profilePic1 = require('../assets/profilePics/111.png');
const profilePic2 = require('../assets/profilePics/222.png');
const profilePic3 = require('../assets/profilePics/33.png');



export { slogan1, slogan2, slogan3, slogan4, realEstate1, realEstate2,  realEstate3,
    badroom, bathroom, propType, profilePic1, profilePic2, profilePic3

};
